import React from "react";
import { Box, Card, Typography, IconButton, Chip } from "@mui/material";
import { DeleteOutline, LocalFireDepartment } from "@mui/icons-material";
import QuantityStepper from "./QuantityStepper";
import { formatPrice, isKotLocked, lineDisplayTotal } from "../utils/helpers";
import { useSession } from "../context/SessionContext";

// One order line, shared by the Cart (pre-placement, always editable) and
// Live Order (post-placement, locked once the kitchen has already KOT-printed
// it) screens — editable is the one thing that differs between those two
// call sites, per line.
export default function OrderLineCard({ item, editable, onQuantityChange, onRemove, busy }) {
  const { currency } = useSession();
  const locked = isKotLocked(item);

  return (
    <Card variant="outlined" sx={{ p: 1.5, mb: 1.25, borderRadius: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
            <Typography variant="subtitle2" fontWeight={700}>
              {item.product?.name}
            </Typography>
            {locked && (
              <Chip
                icon={<LocalFireDepartment sx={{ fontSize: 14 }} />}
                label="Sent to kitchen"
                size="small"
                color="warning"
                sx={{ height: 20, fontSize: 10 }}
              />
            )}
          </Box>
          {item.option?.name && (
            <Typography variant="caption" color="text.secondary" display="block">
              {item.option.name}
            </Typography>
          )}
          {item.addons?.length > 0 && (
            <Typography variant="caption" color="text.secondary" display="block">
              + {item.addons.map((a) => a.name).join(", ")}
            </Typography>
          )}
          {item.notes && (
            <Typography variant="caption" color="text.disabled" display="block">
              Note: {item.notes}
            </Typography>
          )}
        </Box>
        {editable && !locked && (
          <IconButton size="small" onClick={() => onRemove(item)} disabled={busy}>
            <DeleteOutline fontSize="small" />
          </IconButton>
        )}
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1 }}>
        {editable && !locked ? (
          <QuantityStepper value={item.quantity} onChange={(q) => onQuantityChange(item, q)} min={0} disabled={busy} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            Qty: {item.quantity}
          </Typography>
        )}
        <Typography fontWeight={700}>{formatPrice(lineDisplayTotal(item), currency)}</Typography>
      </Box>
    </Card>
  );
}
